import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import ErrorComponent from '../../common/components/ErrorComponent';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import { CondominioQuotesStyles, RiskContainer } from './styles/CondominioResultPage.styles';
import {
  addCondominioMassimaleAmount, addCondominioQuoteToCart, condominioQuotesGetQuotes, condominioQuotesSilentGetQuotes, removeCondominioQuoteFromCart,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import CondominioModal from './components/CondominioModal';
import CondominioModalButtons from './components/CondominioModalButtons';
import { FormInputText } from '../../common/formInputsV2/FormInputText';
import { riskCardStyles } from '../../common/components/redesignComponents/ResultPageComponents/RcQuotesModal.style';
import { RiskCard, RiskButton } from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import { primaQuoteTypes, safeCapitalizeWords } from '../../common/constants';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import CondominioSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/CondominioSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';

const isMassimaleValueType = (typeId) => ['cristalli_e_vetri', 'assistenza'].includes(typeId);

function MassimaleValueInputCard({
  type,
  requestInfo,
  massimaleAmount,
  setMassimaleAmount,
  saveMassimaleAmount,
  riskQuotations,
}) {
  return (
    <RiskCard className={riskCardStyles(requestInfo, type, riskQuotations)}>
      <div className="me-auto">
        <h5>{safeCapitalizeWords(type.name)}</h5>
      </div>
      <div className="my-auto">
        <FormInputText
          label="Inserisci massimale"
          type="number"
          value={massimaleAmount[type.id]}
          onWheel={(e) => e.target.blur()}
          onChange={(value) => setMassimaleAmount({ ...massimaleAmount, [type.id]: value })}
        />
      </div>
      {massimaleAmount[type.id].length >= 3 && (
        <RiskButton onClick={() => saveMassimaleAmount(type)}>
          Salva
        </RiskButton>
      )}
    </RiskCard>
  );
}

function CondominioResultPage() {
  const { requestToken } = useParams();
  const [massimaleAmount, setMassimaleAmount] = useState({
    cristalli_e_vetri: '',
    assistenza: '',
  });
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    // toSelect,
    quote_id_to_add,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.condominio);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  // const [showModal, setShowModal] = useState(false);
  const refresh = () => condominioQuotesGetQuotes(requestToken);
  const silentRefresh = () => condominioQuotesSilentGetQuotes(requestToken);

  const modifyData = () => {
    navigate('/quote/condominio', {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addCondominioQuoteToCart(
      quoteId,
      refresh,
      modifyData,
      closeButton,
      quote_id_to_add,
    ));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeCondominioQuoteFromCart(quoteId, refresh, modifyData));
  };

  useEffect(() => {
    condominioQuotesGetQuotes(requestToken);
  }, [requestToken]);

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    const totalAmount = quoteInProccessAmount + risksTotalAmount;

    if (totalAmount < 160) {
      generalAlertError('Il totale della quotazione deve essere maggiore di 160€ per procedere con l\'acquisto.', 'Errore');
      return;
    }

    navigate(`/quotes/condominio/purchase/${requestToken}`);
  };

  // useEffect(() => {
  //   if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
  //     navigate('/quote/condominio', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, requestToken]);

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  const saveMassimaleAmount = (type) => {
    addCondominioMassimaleAmount(
      requestToken,
      refresh,
      massimaleAmount[type.id],
      setMassimaleAmount,
      type.id,
    );
  };

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  return (
    <>

      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_condominio_result"
        />
      )}
      <V2FontImport />
      <CondominioQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <CondominioSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modifyData={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              rcTypeLabel={processingQuote?.product_name}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>
          {quotations && !quotations.res_civile
            && (
              <div className="alert alert-info mx-2" role="alert">
                <h4 className="alert-heading">Avviso!</h4>
                <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </div>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => {
                    const showMassimaleValueInput = isMassimaleValueType(type.id)
                      && insuranceRequest.product_id == 1003 && quotations?.[type.id] === undefined;

                    return (
                      <React.Fragment key={index}>
                        {quotations && quotations[type.id] && (
                          <CondominioModalButtons
                            insuranceRequest={insuranceRequest}
                            processingQuote={processingQuote}
                            type={type}
                            removeItemFromCart={removeItemFromCart}
                            riskQuotations={riskQuotations}
                          />
                        )}

                        {showMassimaleValueInput
                          && (
                            <MassimaleValueInputCard
                              type={type}
                              requestInfo={insuranceRequest}
                              massimaleAmount={massimaleAmount}
                              setMassimaleAmount={setMassimaleAmount}
                              saveMassimaleAmount={saveMassimaleAmount}
                              riskQuotations={riskQuotations}
                            />
                          )}
                      </React.Fragment>
                    );
                  })}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <CondominioModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>

      </CondominioQuotesStyles>
    </>
  );
}

export default CondominioResultPage;
